import { render, staticRenderFns } from "./VWID42022Disclosure.vue?vue&type=template&id=a60ee986&"
import script from "./VWID42022Disclosure.vue?vue&type=script&lang=js&"
export * from "./VWID42022Disclosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports